module.exports = __webpack_public_path__ + "media/02.c4132c41.mp4";